import { useContext, useEffect, useMemo, useState } from "react";
import { FilterContext } from "src/components/Common/UI/DndTable/TableFilterV2/FilterContext";
import { useGetAllPhonecentersMaintenances } from "../api/getAllPhonecentersMaintenance";
import { useTranslation } from "react-i18next";

// All your logic is here
export const usePhonecentersMaintenancesDataViewLogic = () => {
  const { submitedFilters } = useContext(FilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({ action: "", selectedRows: [] });
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetPhonecentersMaintenance []>([]);
  const getAllPhonecentersMaintenancesQuery = useGetAllPhonecentersMaintenances({data: submitedFilters ? submitedFilters : {}});
  const { t } = useTranslation();

  const loadingDone = [getAllPhonecentersMaintenancesQuery].every(
    ({ isFetching  }) => !isFetching
  );

  const errorData = [getAllPhonecentersMaintenancesQuery].filter(
    ({ isError }) => (isError ? true : false)
  );

  const data = getAllPhonecentersMaintenancesQuery.data ? getAllPhonecentersMaintenancesQuery.data : []

  const columns = useMemo(
    () => [
      {
          id: "1",
          Header: "Συντηρητής",
          accessor: "description",
          show : true,
          isDraggable: false,
      },
  
    ], []
  );

  const closeActionModal = () => {
    setModalEvent({action: "", selectedRows: []});
  }

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Δημιουργία Συντηρητή");
        break;
      case "edit":
        title = t("Επεξεργασία Συντηρητή");
        break
        case "delete":
        title = t("Διαγραφή Συντηρητή");
        break
      default:
        break;
    }
    return title;
  }

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable[0] ? [...[selectedRowsOfTable[0].id]] : [];
    console.log("selectedRows", selectedRows, "selectedRowOfTable", selectedRowsOfTable, "selectedRowOfTable[0]", selectedRowsOfTable[0])
    setModalEvent({action: event.action, selectedRows: selectedRows})
  }

  useEffect(()=>{
    setSelectedRowsOfTable([]);
    getAllPhonecentersMaintenancesQuery.refetch();
  },[ submitedFilters ])


  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction
  };
};
